import articlePage from "@faire/web-api/routes/support/articles/articleId";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var ReturnedToSenderIA = function ReturnedToSenderIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "9LbFDA",
    defaultMessage: [{
      "type": 0,
      "value": "Se tentou enviar uma encomenda e esta lhe foi devolvida, pode ser devido a vários motivos diferentes. Consulte o nosso "
    }, {
      "children": [{
        "type": 0,
        "value": "guia detalhado"
      }],
      "type": 8,
      "value": "ArticleLinkFormatting"
    }, {
      "type": 0,
      "value": " sobre problemas de "
    }, {
      "children": [{
        "type": 0,
        "value": "devolução ao remetente"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " para encontrar os próximos passos recomendados, tanto para envios nacionais como internacionais."
    }],
    values: {
      ArticleLinkFormatting: ArticleLinkFormatting,
      BoldFormatting: BoldFormatting
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "1gsUye",
    defaultMessage: [{
      "type": 0,
      "value": "Contacte-nos se precisar de mais ajuda. Estamos sempre disponíveis para ajudar."
    }]
  })));
};
var ArticleLinkFormatting = function ArticleLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: articlePage("26594585812891"),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var BoldFormatting = function BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};